import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import { Redirect, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loading from 'components/Loading'
import Navbar from './components/Navbar'
import Footer from './containers/Footer'
import Menu from 'layouts/Mobile/Menu'
import './style.scss'

const applicationForExternalCompanies = process.env.REACT_APP_TYPE !== 'mm'

const DesktopMRoute = ({ path, darkNavBar = false, isFooter = true, maxHeight = false, protectedPath = false, isMenu = true, showMenuOnlyWhenUserIsLoggedIn = false, children, isSearch, isBasket: _isBasket, isOrder: _isOrder }) => {
  const isEmptyBasket = useSelector(selectBasketIsEmpty)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const isLoading = useSelector(selectIsLoading)
  const isBasket = !isEmptyBasket || _isBasket
  const isOrder = isBasket || ((applicationForExternalCompanies && showMenuOnlyWhenUserIsLoggedIn && !isLoggedIn)
    ? true
    : _isOrder)

  return (
    (protectedPath && !isLoggedIn)
      ? isLoading
        ? <main>
          <Loading middleOfPage />
        </main>
        : <Redirect to='/login' />
      : <Route path={path}>
        <Navbar isLoggedIn={isLoggedIn} isBlack={darkNavBar} isGray={isOrder} isCategories={isSearch} isBasket={isBasket} />
        {isSearch
          ? children
          : <div className={`desktopWrapper${isBasket ? ' --basket' : ''}${isOrder ? ' --order' : ''}`}>
            {(!isBasket && (applicationForExternalCompanies && showMenuOnlyWhenUserIsLoggedIn ? (isMenu && isLoggedIn) : isMenu))
              ? <>
                <div className='desktopMenu'>
                  <Menu isDesktop />
                </div>
                <div className='desktopContent'>
                  <div className={`desktopContent__wrap ${maxHeight ? '--maxH' : ''}`}>
                    {children}
                  </div>
                </div>
              </>
              : <div className='desktopContent__wrap'>
                {children}
              </div>}
          </div>}
        {isFooter && isSearch && <Footer />}
      </Route>
  )
}

export default DesktopMRoute